// extracted by mini-css-extract-plugin
export default {"sizingLimit":"CardModal_sizingLimit__zltHm"};